





import { defineComponent } from '@vue/composition-api';

import PanelWithProductEditor from '@/components/Store/PanelWithProductEditor.vue';

const EditProduct = defineComponent({
  components: {
    PanelWithProductEditor,
  },
  // setup() {},
});

export default EditProduct;
